/*

THIS REDUCER IS USED TO SAVE SELECTED OPTIONS IN THE SHIPPING METHOD 

*/

import * as types from '../actions/actionTypes';

export const shippingMethodReducer = (state = {selection: {date: null, zone: null,day: null, dateInfo: '', type: '', options: null, selectedOption: null, time: '', timeWindow: null, todayDateInfo: {}}, pickupStore: {}}, action) => {
    var newState = { ...state }
    switch (action.type) {
        case types.SET_SHIPPING_SELECTION:
            let fieldsLength = action.payload.length;
            for (let i = 0; i < fieldsLength; i++) {
              const data = action.payload[i];
              newState.selection[data.fieldToUpdate] = data.value;
            }
            return newState;
            break;
        case types.SET_PICKUP_STORE:
            newState.pickupStore = {...action.payload};
            return newState;
            break;    
        default:
            return state;
    }
}
